import {css} from 'lit'; export default css`chameleon-chip-v2{cursor:pointer}`;
    